export var paymentSelector = function paymentSelector(state) {
  return state.payment;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/PaymentState.selectors.js
// module id = 196
// module chunks = 11